import React, { useEffect, useState, lazy } from 'react';
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { isMobile } from 'react-device-detect'; // Detect device type
import { ThemeProvider } from 'styled-components';
import $ from 'jquery';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { isLoaded } from 'react-redux-firebase';
import { ConfigProvider } from 'antd';
import FirebaseService from './config/database/firebase';
import store from './redux/store';
import Home from './routes/index';
import NewHome from './routes/index-2.0';
import KioskHome from './routes/kiosk-index';

import ProtectedRoute from './utilities/protected-route';
import { getSession, setSession } from './services/storage-service';
import { getIsNewUI, setBizCode, setBusinessDetails, getTemplateLandingPage } from './services/business-details-service';
import { setLoginRes, getLoginBusinessId, getLoginAccountId, setIsPublicFormLoaded, getIsPublicFormLoaded, setPublicFormErrorMessage } from './services/auth-details-service';
import { SESSION_KEYS } from './utilities/constants/index';
import { getBizDetails } from './actions/api-actions';
import { ErrorModal } from './components/cp-modals/cp-modal';
import './static/css/style.css';
import './static/css/loader.css';
import './static/css/dashboard.css';
import './static/css/teams.css';

import config from './config/config';
import 'antd/dist/antd.less';
import { getCurrencySymbol, gotoLoginPage } from './utilities/utility';
import DynamicTitleAndFavicon from './components/business-info';
import useDeviceDetect from './hooks/use-device-detect';
import HooperLoading from './components/cp-spinners/cp-spinner';
import logger from './services/logger';
import DynamicMsalProvider from './providers/dynamic-msal-provider';
// eslint-disable-next-line import/no-named-as-default
import ApiService from './config/api/api-service';
import { ApiLibrary } from './config/api/api-library';
import { LOGIN_SUCCESS } from './constants/actions';

const Auth = lazy(() => import('./routes/auth'));

const { theme } = config;

const ProviderConfig = () => {
  const currentURL = window?.location?.href;

  let isLoggedIn = false;
  let loginRes = {};
  let bizCode = '';
  const [isFireBaseLoad, setIsFireBaseLoad] = useState(false);
  const isNewUi = getIsNewUI();
  const dispatch = useDispatch();
  let isKioskMode = false;

  // handled public form functionality
  const formId = currentURL.substring(currentURL.lastIndexOf('/') + 1);
  if (currentURL?.includes('public/form') && !currentURL?.includes('public/forms/complaints') && !currentURL?.includes('public/forms/observations') && !getIsPublicFormLoaded()) {
    setIsPublicFormLoaded(true);
    const { userAgent } = navigator;
    let browser = 'Other';
    if (userAgent.includes("Chrome")) {
      browser = 'Chrome';
    } else if (userAgent.includes("Firefox")) {
      browser = 'Firefox';
    } else if (userAgent.includes("Safari")) {
      browser = 'Safari';
    }
    const postJsonData = {
      browser,
      device: isMobile ? 'mobile' : 'web',
      ipAddress: ''
    }
    try {
      // Get IP address using an external API
      fetch('https://api.ipify.org?format=json')
        .then((response) => response.json())
        .then((data) => {
          postJsonData.ipAddress = data?.ip;
          $.ajax({
            type: "POST",
            async: false,
            url: `${ApiService.baseURL}/${ApiLibrary?.V2?.PUBLIC_FORM_DATA}/${formId}`,
            headers: {
              'Content-type': 'application/json'
            },
            dataType: "json",
            data: JSON.stringify(postJsonData),
            success(response) {
              const res = response;
              if (res?.statusCode === 0) {
                if (res?.data) {
                  const key = `${res?.data?.bizCode}${SESSION_KEYS.LOGIN_RES}`;
                  res.data.access_token = res?.data?.token;
                  res.data['x-business-id'] = res?.data?.businessId;
                  res.data.account_id = res?.data?.accountId;
                  res.data.publicFormUrlResponse = {
                    ...postJsonData,
                    publicFormUrlId: formId
                  }
                  setSession(`${key}`, response?.data, true);
                  setSession(`${SESSION_KEYS.DEFAULT_BIZ_CODE}`, res?.data?.bizCode);
                  dispatch({ type: LOGIN_SUCCESS, payload: response?.data });
                  setSession(`${response.data?.realm}${SESSION_KEYS.LOGIN_RES}`, response?.data, true);
                }
              } else {
                isLoggedIn = false;
                loginRes = {};
                bizCode = '';
                gotoLoginPage(true);
                setPublicFormErrorMessage(res?.statusMessage);
                logger.warn(res?.statusMessage);
                logger.warn(res?.statusMessage);
              }
            }
          });
        })
        .catch((error) => console.error("Error fetching IP address:", error));

    } catch (error) {
      // Handle error here
      logger.error('An error occurred:', error);
    }
  }

  if (currentURL?.includes('https://uflex.kellton.net') && !currentURL?.includes('/bizCode')) {
    window.location.href = `https://uflex.kellton.net/bizCode6/login`;
  }
  if (currentURL?.includes('https://tcp.kellton.net') && !currentURL?.includes('/bizCode')) {
    window.location.href = `https://tcp.kellton.net/bizCode4/login`;
  }
  if (currentURL?.includes('https://adani.kellton.net') && !currentURL?.includes('/bizCode')) {
    window.location.href = `https://adani.kellton.net/bizCode13/login`;
  }
  if (currentURL?.includes('https://tcpehs.kellton.net') && !currentURL?.includes('/bizCode') && !currentURL?.includes('/public')) {
    window.location.href = `https://tcpehs.kellton.net/bizCode14/login`;
  }
  if (currentURL?.includes('https://omya.kellton.net') && !currentURL?.includes('/bizCode')) {
    window.location.href = `https://omya.kellton.net/bizCode18/login`;
  }
  if (currentURL?.includes('https://tcpsop.kellton.net') && !currentURL?.includes('/bizCode')) {
    window.location.href = `https://tcpsop.kellton.net/bizCode19/login`;
  }
  if (currentURL?.includes('/bizCode')) {
    const values = currentURL.split('/');
    values.forEach((value) => {
      if (value.includes('bizCode')) {
        bizCode = value;
      }
    });
    // getting the kiosk mode status
    const kioskKey = `${bizCode}_${SESSION_KEYS.KIOSK_MODE}`;
    const isMode = getSession(`${kioskKey}`, true);
    isKioskMode = isMode?.mode;
  } else {
    bizCode = getSession(`${SESSION_KEYS.DEFAULT_BIZ_CODE}`);
    // getting the kiosk mode status
    const kioskKey = `${bizCode}_${SESSION_KEYS.KIOSK_MODE}`;
    const isMode = getSession(`${kioskKey}`, true);
    isKioskMode = isMode?.mode;
  }

  if (Object.keys(bizCode)?.length > 0 && bizCode?.includes('bizCode')) {
    const key = `${bizCode}${SESSION_KEYS.LOGIN_RES}`;
    loginRes = getSession(`${key}`, true) || {};
    if (loginRes?.access_token) {
      isLoggedIn = true;
      setBizCode(bizCode);
      setLoginRes(loginRes);
    }
  }

  if (currentURL?.includes('newBusiness')) {
    isLoggedIn = false;
  } 

  // getting the device type based on the screen resolution
  const deviceType = useDeviceDetect();
  if (deviceType) {
    setSession('DEVICE_TYPE', deviceType);
  }

  const setBizDetails = async (code) => {
    try {
      const response = await getBizDetails(code);
      if (response?.data?.statusCode === 0) {
        getCurrencySymbol(response?.data?.data);
        await dispatch(setBusinessDetails(response?.data?.data));
      } else if (response?.data?.statusMessage) {
        ErrorModal({
          data: {
            modalTitle: '',
            modalContent: response?.data?.statusMessage,
            width: 600,
          },
        });
      }
    } catch (error) {
      logger.error(error);
    }
  };
// Add a check in the React code to ensure the page is not loaded in an iframe
  useEffect(() => {
    if (window.self !== window.top) {
      // If loaded in an iframe, redirect or show a warning
      window.top.location = window.location.href;
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (currentURL?.includes('/bizCode') || isLoggedIn) {
        setBizCode(bizCode);
        await setBizDetails(bizCode);
        if (isLoggedIn && !currentURL?.includes('/home')) {
          const templateLandingPage = getTemplateLandingPage();
          if (currentURL?.includes('public/form') && !currentURL?.includes('public/forms/complaints') && !currentURL?.includes('public/forms/observations')) {
            window.location.href = `${window.location.origin}/home/${bizCode}/public/form/${formId}`;
          }
          else if (templateLandingPage === 'APPS' && !isKioskMode) {
            window.location.href = `${window.location.origin}/home/${bizCode}/apps`;
          } else if (isKioskMode) {
            window.location.href = `${window.location.origin}/home/${bizCode}/kiosk/apps/list`;
          } else {
            window.location.href = `${window.location.origin}/home/${bizCode}/business/dashboard`;
          }
        }
      } 
      if (!isLoggedIn) {
        setTimeout(() => {
          setIsFireBaseLoad(true);
        }, 1000);
      }
    };

    fetchData();
  }, [bizCode, isLoggedIn]);

  const { auth, biz } = useSelector((state) => {
    return {
      auth: loginRes,
      biz: state?.biz?.bizData,
    };
  });

  const fireBaseLoadFunc = () => {
    setIsFireBaseLoad(true);
    logger.info("FIRE BASE LOAD ", isFireBaseLoad);
  }

  return (
    <ConfigProvider direction="ltr">
      <ThemeProvider theme={{ ...theme }}>
        {!isLoaded(auth) && !isLoaded(biz) && !isLoaded(isFireBaseLoad) ? (
          <div className="spin">
            <HooperLoading />
          </div>
          ) : (
            <>
              <DynamicMsalProvider clientId={biz?.loginPrefs?.aadAppId} tenantId={biz?.loginPrefs?.aadTenantId}>

              {isLoggedIn && (
                <FirebaseService businessId={getLoginBusinessId()} bizAccountRefId={getLoginAccountId()} setFireBaseLoad={(data) => fireBaseLoadFunc(data)} />
              )}
              {isFireBaseLoad ? (
                <Router>
                  {isLoggedIn ? (
                      <ProtectedRoute path="/home/:bizCode" component={isNewUi ? (isKioskMode ? KioskHome : NewHome) : (isKioskMode ? KioskHome : Home)} />
                  ) : (
                    <Route path="/" component={Auth} />
                  )}
                  <DynamicTitleAndFavicon />
                </Router>
              ) : (
                <div className="spin">
                  <HooperLoading />
                </div>
                )}
              </DynamicMsalProvider>
            </>
          )}
          {/* {showFloatingArrowButton && (
            <Button
              type="primary"
              icon={<FontAwesomeIcon icon={faChevronUp} />}
              className="arrow-floating-button"
              onClick={scrollToTop}
            />
          )} */}
      </ThemeProvider>
    </ConfigProvider>
  );
};

function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default hot(App);
